export enum DatasetMode {
  MAP_EXISTING = 'MAP_EXISTING',
  CREATE_OVERWRITE = 'CREATE_OVERWRITE',
}

export enum DatasetConflict {
  USE_EXISTING_IF_SAME_NAME = 'USE_EXISTING_IF_SAME_NAME',
  OVERWRITE = 'OVERWRITE',
}
